import {NgModule} from '@angular/core';
import {ToolbarCustomComponent} from './toolbar-custom/toolbar-custom';
import {IonicModule} from "ionic-angular";
import {SelectMoreMinusComponent} from "./select-more-minus/select-more-minus.component";
import {CommonModule} from "@angular/common";

@NgModule({
  declarations: [ToolbarCustomComponent, SelectMoreMinusComponent
   ],
  imports: [IonicModule.forRoot(ToolbarCustomComponent), CommonModule, IonicModule],
  exports: [ToolbarCustomComponent, SelectMoreMinusComponent
   ]
})
export class ComponentsModule {
}



// WEBPACK FOOTER //
// ./src/components/components.module.ts